import { render, staticRenderFns } from "./MetaLeadsConnection.vue?vue&type=template&id=12ecc49e&scoped=true&"
import script from "./MetaLeadsConnection.vue?vue&type=script&lang=js&"
export * from "./MetaLeadsConnection.vue?vue&type=script&lang=js&"
import style0 from "./MetaLeadsConnection.vue?vue&type=style&index=0&id=12ecc49e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ecc49e",
  null
  
)

export default component.exports